export default __webpack_public_path__ + "static/media/outgoing-white.17ee2a7e.svg";